<template>
  <div class="w-full h-full">
    <deep-chat
      ref="chat"
      :demo.prop="demoConfig"
      :connect.prop="connection"
      :focusMode.prop="focusMode"
      :textInput.prop="textInputStyles"
      :avatars.prop="avatars"
      :history.prop="history"
      :customButtons.prop="finalCustomButtons"
      :messageStyles.prop="messageStyles"
      :auxiliaryStyle.prop="finalAuxiliaryStyle"
      :submitButtonStyles.prop="submitButtonStyles"
      :requestInterceptor.prop="requestInterceptor"
      style="width: 100%; height: 100%; display: block; user-select: text; font-family: 'Exo2';"
      :style="chatStyle"
      @message="onMessage"
      @render="onRender"
    >
      <div :class="{ dark: darkMode }">
        <div v-if="chatName" style="text-align: center; margin-bottom: 8px; font-size: 16px"
          :style="darkMode ? 'color: var(--darkblue-100)' : ''"
          >
          <b>{{ chatName }}</b>
        </div>
        <i18n path="ia.disclaimer" tag="div" style="font-size: 14.6px; line-height: 20px; margin-left: 20px; margin-right: 20px"
          :style="darkMode ? 'color: var(--darkblue-100)' : ''"
          >
          <template #email>
            <a class="support-email-link" :href="`mailto:${supportEmail}`">
              {{supportEmail}}
            </a>
          </template>
        </i18n>
        <div v-if="showCallButton" style="font-size: 14.6px; line-height: 20px; margin-left: 20px; margin-right: 20px; margin-top: .5rem; display: flex; flex-direction: column; gap: 0.5rem;"
          :style="darkMode ? 'color: var(--darkblue-100)' : ''"
        >
          <base-button mode="secondary-phantom-blue" class="intro-action" style="border: 0; font-family: inherit;" @click="toggleSupportModal">
            {{ $t('ia.disclaimer_call') }}
            <base-icon :style="callIconStyle" name="phone-out" :aria-hidden="true" />
          </base-button>
        </div>
      </div>
    </deep-chat>
    <CallSuportDialog v-if="showCallButton" :dialogOpen="showSupportModal" @toggleDialog="toggleSupportModal" />
  </div>
</template>

<script>
import 'deep-chat'
// eslint-disable-next-line import/no-webpack-loader-syntax
import baseButtonStyles from '!!css-loader!postcss-loader!sass-loader!@/assets/scss/BaseButton.scss'
import { i18n } from '@/i18n'
import { refreshAccessToken } from '@/services/axiosInstance'
import { shouldRefreshAccessToken } from '@/utils/token'
import '@/scripts/iaComponents/imgCarrousel.js'
import iaDemoResponse from '@/services/functions/iaDemoResponse'
import CallSuportDialog from '@/components/CallSuportDialog.vue'

export default {
  name: 'ai-chat',
  components: {
    CallSuportDialog
  },
  props: {
    chatName: {
      type: String,
      default: ''
    },
    demoRole: {
      type: String,
      default: 'ai'
    },
    endpoint: {
      type: String,
      required: true
    },
    disableInput: {
      type: Boolean,
      default: false
    },
    showCallButton: {
      type: Boolean,
      default: false
    },
    auxiliaryStyle: {
      type: String,
      default: ''
    },
    customButtons: {
      type: Array,
      default: () => []
    },
    additionalBodyProps: {
      type: Object,
      default: () => ({})
    },
    textInputStylesValues: {
      type: Object,
      default: () => ({
        styles: {
          text: { color: 'black' },
          container: { maxHeight: '50px', backgroundColor: 'var(--darkblue-50)', border: '2px solid var(--secondary-500)' },
          focus: { border: '2px solid var(--secondary-900)' },
        },
        placeholder: { text: i18n.t('ia.placeholder'), style: { color: 'var(--secondary-DEFAULT)' } },
        characterLimit: 300,
      })
    },
  },
  data: function () {
    return {
      history: [],
      localHistory: [],
      focusMode: { scroll: true, fade: 500 },
      supportEmail: 'soporte@zerocoma.com',
      showSupportModal: false
    }
  },
  computed: {
    isDemo () {
      return ['dev', 'test'].includes(process.env.VUE_APP_ENVIRONMENT) && false
    },
    demoConfig () {
      if (!this.isDemo) return undefined
      return {
        response: message => iaDemoResponse(this.demoRole, { ...message, ...this.additionalBodyProps })
      }
    },
    connection () {
      if (this.isDemo) return { stream: true }
      return {
        url: process.env.VUE_APP_AIAPI + this.endpoint,
        method: 'POST',
        stream: true,
      }
    },
    role () {
      return this.$store.getters['auth/role']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    finalCustomButtons () {
      return this.customButtons || []
    },
    callIconStyle () {
      const size = '1.5em'
      return {
        marginInline: '0.5em',
        fill: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        verticalAlign: 'middle',
        width: size,
        height: size
      }
    },
    textInputStyles: function () {
      return this.textInputStylesValues
    },
    messageStyles: function () {
      return {
        default: {
          // ai: {
          //   bubble: {
          //     backgroundColor: '#4a4e59',
          //     color: 'white'
          //   }
          // },
          user: {
            bubble: {
              background: this.darkMode ? 'var(--darkblue-500)' : 'var(--primary-800)',
              color: 'white'
            }
          },
          shared: { 
            bubble: { maxWidth: '85%' },
          },
        },
        // loading: {
        //   bubble: { backgroundColor: '#4a4e59', color: 'white' }
        // }
      }
    },
    submitButtonStyles () {
      return {
        submit: {
          svg: {
            styles: {
              default: {
                filter: 'none',
                color: 'var(--secondary-800)'
              }
            }
          }
        },
        position: 'inside-right'
      }
    },
    chatStyle: function () {
      return this.darkMode
        ? {
          'background-color': 'var(--darkblue-DEFAULT)',
          'border-color': 'var(--darkblue-DEFAULT)',
          color: 'var(--darkblue-100)'
        }
        : {
          'background-color': 'var(--secondary-50)'
        }
    },
    userAvatars: function () {
      const property = this.darkMode ? '--darkblue-200' : '--secondary-DEFAULT'
      const color = getComputedStyle(document.querySelector(':root')).getPropertyValue(property)
      return {
        common: `
        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.8801926,5.84392631 C22.6465388,9.38471849 22.6998717,14.3131295 20.072206,17.903014 L20.0800921,17.9134721 L19.7334427,18.3401238 L19.7334427,18.3401238 C17.8356281,20.655053 15.000559,21.9980002 12.0071603,22 C11.8006929,22.0001374 11.5954393,21.9939562 11.3916061,21.9816214 C11.3709993,21.9793644 11.3506607,21.9780349 11.3303323,21.9766435 C8.3399558,21.778425 5.66057077,20.2544797 3.94745801,17.9296035 L3.93422849,17.9134721 C3.14038855,16.8294483 2.55526239,15.5735546 2.24533494,14.1974025 C1.2173912,9.63308618 3.49164152,4.9661492 7.71984448,2.96328683 C11.9480474,0.960424455 16.9997649,2.15711526 19.8801926,5.84392631 Z M12.0071603,3.33398333 C7.22093052,3.33398333 3.34092467,7.21404612 3.34092467,12.0003461 C3.34092467,13.8061948 3.89325039,15.483039 4.83818398,16.8711586 C6.71307233,14.9421923 9.29555256,13.8417345 12.0071603,13.8417345 C14.7192347,13.8417345 17.3021371,14.942571 19.1763033,16.8703188 C20.1208053,15.4838431 20.6733959,13.8066278 20.6733959,12.0003461 C20.6733959,7.21404612 16.7933901,3.33398333 12.0071603,3.33398333 Z M12.0071603,4.66726991 C14.2161894,4.66726991 16.0069614,6.45806812 16.0069614,8.66712967 C16.0069614,10.8761912 14.2161894,12.6669894 12.0071603,12.6669894 C9.79813117,12.6669894 8.00735924,10.8761912 8.00735924,8.66712967 C8.00735924,6.45806812 9.79813117,4.66726991 12.0071603,4.66726991 Z"
              fill-rule="evenodd"
              fill="${color}">
            </path>
          </svg>`.trim(),
        sadmin: `
        <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m19.52315,6.82579c2.76635,3.54079 2.81968,8.4692 0.19202,12.05908l0.00788,0.01046l-0.34665,0.42665l0,0c-1.89781,2.31493 -4.73288,3.65788 -7.72628,3.65988c-0.20647,0.00014 -0.41172,-0.00604 -0.61555,-0.01838c-0.02061,-0.00226 -0.04095,-0.00359 -0.06128,-0.00498c-2.99037,-0.19822 -5.66976,-1.72216 -7.38287,-4.04704l-0.01323,-0.01613c-0.79384,-1.08402 -1.37897,-2.33992 -1.6889,-3.71607c-1.02794,-4.56431 1.24631,-9.23125 5.47451,-11.23411c4.22821,-2.00287 9.27992,-0.80617 12.16035,2.88064zm-7.87303,-2.50995c-4.78623,0 -8.66624,3.88007 -8.66624,8.66637c0,1.80584 0.55233,3.48269 1.49726,4.87081c1.87489,-1.92897 4.45737,-3.02943 7.16898,-3.02943c2.71207,0 5.29498,1.10084 7.16914,3.02859c0.94451,-1.38648 1.4971,-3.06369 1.4971,-4.86997c0,-4.7863 -3.88001,-8.66637 -8.66624,-8.66637zm0,1.33329c2.20903,0 3.9998,1.7908 3.9998,3.99986c0,2.20906 -1.79077,3.99986 -3.9998,3.99986c-2.20903,0 -3.9998,-1.7908 -3.9998,-3.99986c0,-2.20906 1.79077,-3.99986 3.9998,-3.99986z"
              fill-rule="evenodd"
              fill="${color}">
            </path>
            <path d="m14.83833,7.31377l-6.23281,0c-0.08842,0 -0.16457,-0.07983 -0.18215,-0.19103l-0.88173,-5.54531c-0.01478,-0.09283 0.0146,-0.18805 0.07494,-0.2427c0.06025,-0.05477 0.14003,-0.05835 0.20325,-0.00943l2.37889,1.84005l1.35667,-3.50302c0.03115,-0.08042 0.09493,-0.13173 0.16495,-0.13245c0.06592,-0.00036 0.13436,0.04904 0.16662,0.12887l1.40167,3.47223l2.33547,-1.80556c0.06332,-0.04892 0.14291,-0.04522 0.20325,0.00943s0.08973,0.14987 0.07503,0.2427l-0.88173,5.54531c-0.01785,0.11109 -0.094,0.19091 -0.18233,0.19091z"
              fill-rule="evenodd"
              fill="${color}">
            </path>
          </svg>`.trim()
      }
    },
    userAvatar: function () {
      return this.role === 3 ? this.userAvatars.sadmin : this.userAvatars.common
    },
    avatars: function () {
      return {
        ai: {
          // El path debe ser relativo a public
          src: '/logos/ia/chatbot.svg'
        },
        'ai-mode': {
          // El path debe ser relativo a public
          src: '/logos/ia/Z3R0_2_head.svg'

        },
        user: {
          src: `data:image/svg+xml;base64,${btoa(this.userAvatar)}`
        }
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-DEFAULT', '--primary-800', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `${baseButtonStyles}
        :root { ${rootStyle} }
        ::-webkit-scrollbar { width: 8px; height: 8px; }
        ::-webkit-scrollbar-track { background-color: transparent; }
        ::-webkit-scrollbar-thumb { background-color: var(--primary-DEFAULT); border-radius: 20px; }
        ::-webkit-scrollbar-corner { background: var(--Component-background-); }
        ::-webkit-scrollbar-thumb:hover { background: var(--primary-800); }
        ::-webkit-scrollbar-button { height: 2px; width: 2px; }
        :host { font-family: 'Exo2'; }
        #dropup-menu {
          max-height: min(50vh, 20rem);
          overflow-x: hidden;
          overflow-y: auto;
          overscroll-behavior: contain;
        }
        .cbutton.intro-action {
          background-color: var(--secondary-100);
        }
        a {
          color: var(--primary-800) !important;
        }
      `
    },
    finalAuxiliaryStyle: function () {
      return `${this.getScrollBarsStyle} ${this.auxiliaryStyle}`
    },
    requestInterceptor () {
      return async (requestDetails) => {
        if (requestDetails.body instanceof FormData) {
          Object.entries(this.additionalBodyProps).forEach(([key, value]) => {
            requestDetails.body.set(key, typeof value === 'string' ? value : JSON.stringify(value))
          })
        } else {
          requestDetails.body = { ...requestDetails.body, ...this.additionalBodyProps }
        }
        try {
          let token = this.$store.getters['auth/accessToken']
          if (shouldRefreshAccessToken(token)) {
            token = await refreshAccessToken()
          }
          requestDetails.headers = {
            ...(requestDetails.headers || {}),
            Authorization: 'Bearer ' + token
          }
        } catch (e) {
          return { error: this.$t('ia.sessionExpired') }
        }
        return requestDetails
      }
    }
  },
  watch: {
    disableInput: {
      immediate: true,
      handler (isDisabled) {
        if (this.$refs.chat) {
          this.$refs.chat.disableSubmitButton(isDisabled)
        }
      }
    },
    darkMode: function (value, oldValue) {
      if (value !== oldValue) {
        this.history.push(...this.localHistory)
        this.localHistory = []
      }
    }
  },
  mounted () {
    const chatElementRef = this.$refs.chat
    chatElementRef.disableSubmitButton(this.disableInput)

    chatElementRef.responseInterceptor = (response) => {
      if (response.html !== undefined) {
        chatElementRef.addMessage({ html: response.html, role: response.role })
        response.html = undefined
      }
      return response
    }

    chatElementRef.htmlClassUtilities = {
      'custom-button': {
        events: {
          click: (event) => {
            const text = event.target.children[0].innerText
            chatElementRef.submitUserMessage(text.substring(1, text.length - 1))
          },
        },
        styles: {
          default: {
            backgroundColor: '#f2f2f2',
            borderRadius: '10px',
            padding: '10px',
            cursor: 'pointer',
            textAlign: 'center',
          },
          hover: { backgroundColor: '#ebebeb' },
          click: { backgroundColor: '#e4e4e4' },
        },
      },
      'custom-button-text': { styles: { default: { pointerEvents: 'none' } } },
    }
  },
  methods: {
    syncSubmitDisabled () {
      if (this.$refs.chat) {
        this.$refs.chat.disableSubmitButton(this.disableInput)
      }
    },
    toggleSupportModal (event) {
      this.$emit('toggleSupportModal', event)
      this.showSupportModal = !this.showSupportModal
    },
    onMessage (event) {
      const { message, isHistory } = event.detail
      if (!isHistory) {
        this.localHistory.push(message)
      }
    },
    onRender (event) {
      this.syncSubmitDisabled()
      this.$emit('render', event)
    }
  }
}
</script>
